// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-scheme-light {
	--mdh-background-color-0: #fff;
	--mdh-background-color-1: #f5f5f5;
	--mdh-background-color-2: #ddd;
	--mdh-background-color-inverted: #000;

	--mdh-border-color-0: #eee;
	--mdh-border-color-1: #ddd;
	--mdh-border-color-2: #bbb;

	--mdh-text-color-0: #000;
	--mdh-text-color-1: #333;
	--mdh-text-color-2: #555;
	--mdh-text-color-3: #999;
	--mdh-text-color-4: #bbb;

	--default-highlight-color: #0C509B;
	color: var(--mdh-text-color-1);
}

.color-scheme-dark {
	--mdh-background-color-0: #2c2c2d;
	--mdh-background-color-1: #1c1c1d;
	--mdh-background-color-2: #000;
	--mdh-background-color-inverted: #FFFFFF;

	--mdh-border-color-0: #444446;
	--mdh-border-color-1: #444;
	--mdh-border-color-2: #555;

	--mdh-text-color-0: #FFF;
	--mdh-text-color-1: #FFF;
	--mdh-text-color-2: #9e9ea5;
	--mdh-text-color-3: #59595d;
	--mdh-text-color-4: #59595d;

	--default-highlight-color: #4482c8;
	color: var(--mdh-text-color-1);
}
`, "",{"version":3,"sources":["webpack://./src/components/MyDataHelps/colors.css"],"names":[],"mappings":"AAAA;CACC,8BAA8B;CAC9B,iCAAiC;CACjC,8BAA8B;CAC9B,qCAAqC;;CAErC,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;;CAE1B,wBAAwB;CACxB,wBAAwB;CACxB,wBAAwB;CACxB,wBAAwB;CACxB,wBAAwB;;CAExB,kCAAkC;CAClC,8BAA8B;AAC/B;;AAEA;CACC,iCAAiC;CACjC,iCAAiC;CACjC,8BAA8B;CAC9B,wCAAwC;;CAExC,6BAA6B;CAC7B,0BAA0B;CAC1B,0BAA0B;;CAE1B,wBAAwB;CACxB,wBAAwB;CACxB,2BAA2B;CAC3B,2BAA2B;CAC3B,2BAA2B;;CAE3B,kCAAkC;CAClC,8BAA8B;AAC/B","sourcesContent":[".color-scheme-light {\n\t--mdh-background-color-0: #fff;\n\t--mdh-background-color-1: #f5f5f5;\n\t--mdh-background-color-2: #ddd;\n\t--mdh-background-color-inverted: #000;\n\n\t--mdh-border-color-0: #eee;\n\t--mdh-border-color-1: #ddd;\n\t--mdh-border-color-2: #bbb;\n\n\t--mdh-text-color-0: #000;\n\t--mdh-text-color-1: #333;\n\t--mdh-text-color-2: #555;\n\t--mdh-text-color-3: #999;\n\t--mdh-text-color-4: #bbb;\n\n\t--default-highlight-color: #0C509B;\n\tcolor: var(--mdh-text-color-1);\n}\n\n.color-scheme-dark {\n\t--mdh-background-color-0: #2c2c2d;\n\t--mdh-background-color-1: #1c1c1d;\n\t--mdh-background-color-2: #000;\n\t--mdh-background-color-inverted: #FFFFFF;\n\n\t--mdh-border-color-0: #444446;\n\t--mdh-border-color-1: #444;\n\t--mdh-border-color-2: #555;\n\n\t--mdh-text-color-0: #FFF;\n\t--mdh-text-color-1: #FFF;\n\t--mdh-text-color-2: #9e9ea5;\n\t--mdh-text-color-3: #59595d;\n\t--mdh-text-color-4: #59595d;\n\n\t--default-highlight-color: #4482c8;\n\tcolor: var(--mdh-text-color-1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
